import { ReactNode } from "react";

type BottomConfirmBarProps = {
  label: ReactNode;
  disabled?: boolean;
  onClick: () => void;
  note?: ReactNode;
  className?: string;
};

export const BottomConfirmBar = ({
  label,
  disabled = false,
  onClick,
  note,
  className
}: BottomConfirmBarProps) => {
  return (
    <footer className={`bottom-confirm-bar${className ? ` ${className}` : ""}`} onClick={(e) => e.stopPropagation()}>
      <button type="button" className="primary-button" disabled={disabled} onClick={onClick}>
        {label}
      </button>
      {note ? <p className="bottom-confirm-note">{note}</p> : null}
    </footer>
  );
};
